import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.scss";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? "navbar--scrolled" : ""}`}>
      <div className="navbar__container">
        <Link to="/" className="navbar__logo">
          RH
        </Link>

        <div className="navbar__links">
          <Link
            to="/"
            className="navbar__link"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Home
          </Link>
          <Link
            to="/projects"
            className="navbar__link"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Projects
          </Link>
          <Link
            to="/skills"
            className="navbar__link"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Skills
          </Link>
          <Link
            to="/contact"
            className="navbar__link"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
